module.exports = __webpack_public_path__ + "static/media/MomentosBravectoCard3.a0ac872f.webp";